import { MiddlewareAPI, Middleware } from '@reduxjs/toolkit'
import i18n from 'i18n';
// Models
import { AppDispatch } from 'app/store';
import { ICurrentAccount } from 'app/models/Account';
// Types
import AccountStatuses from 'app/types/AccountStatuses';
// Async
import { getCurrentAccount } from 'app/store/Accounts/Accounts.async';
// Actions
import { AppUiNotificationsActions } from 'app/store/AppUINotifications/AppUINotifications.slice';
import { DMSCollectionsActions } from 'app/store/DMSCollections/DMSCollections.slice';
// Services
import Mixpanel from "app/services/Mixpanel.service";
import LocalStorageService from 'app/services/LocalStorage.service';

const AccountsMiddleware:Middleware = ({ dispatch }:MiddlewareAPI<AppDispatch>) => (next:any) => (action:any) => {
  const { type, payload } = action;

  if ( type === getCurrentAccount.fulfilled.type ){
    const currentAccount = payload as ICurrentAccount;

    Mixpanel.registerOnceAccountId(currentAccount.id);

    const collectionId = LocalStorageService.getCollectionTab(currentAccount.id);
    dispatch(DMSCollectionsActions.setSelectedCollectionId(collectionId));

    if ( currentAccount.status === AccountStatuses.Suspended ){
      dispatch(AppUiNotificationsActions.addSystemMessage({
        type: 'message',
        message: i18n.t('notifications.accountsMiddleware.yourAccountSuspended'),
        forceShow: true
      }));
    }
  }

  return next(action);
}

export default AccountsMiddleware;
